import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { environment } from './../../../../environments/environment';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private authService: AuthService
	) { }

	ngOnInit(): void {
		this.route.queryParams.subscribe(({ redirect, hash }) => {
			let destinationRoute = '/dashboard/home';
			if (redirect) {
				destinationRoute = redirect;
			}

			if (hash) {
				this.authService.login(hash).subscribe({
					complete: () => {
						this.router.navigate([destinationRoute]);
					},
					error: () => {
						window.location.href = `${environment.adminUrl}/auth/logout`;
					}
				});
			}else{
				if (!this.authService.verificateAuthentication()) {
					this.authService.clearSession();
					window.location.href = `${environment.adminUrl}/auth/logout`;
				} else {
					this.router.navigate([destinationRoute]);
				}
			}
		});
	}
}
